import { useQuery } from "@rocicorp/zero/react"

import { Button, SlackIcon, Tooltip } from "@productlane/ui"
import { queries } from "@productlane/zero/queries"

import { useSlackConnections } from "@/lib/zero"
import { getSlackChannelRow } from "../../lib/slack-message-link"
import { useThreadContext } from "../../thread-context"

/** Read only: the Slack channel a thread came from. DMs and unsynced channels have no stored row, so they show nothing. */
export function ThreadSlackChannelRow() {
	const { thread } = useThreadContext()
	const connections = useSlackConnections()
	const [channel] = useQuery(
		queries.slackChannelByChannelId({ channelId: thread.slackChannelId ?? "" }),
		{ enabled: Boolean(thread.slackChannelId), ttl: "10m" },
	)
	if (!thread.slackChannelId || !channel) return null

	const { label, url } = getSlackChannelRow({ channel, connections })
	const row = (
		<Button
			variant="ghost"
			Icon={SlackIcon}
			iconClassName="h-4 w-4"
			className="h-auto min-w-[145px] max-w-full justify-start text-xs !text-primary"
		>
			<span className="truncate">{label}</span>
		</Button>
	)
	if (!url) return row

	return (
		<Tooltip label="Open in Slack">
			<a href={url} target="_blank" rel="noreferrer" className="max-w-full">
				{row}
			</a>
		</Tooltip>
	)
}
